import * as EventQueries from 'queries/event';
import { makeApolloClient, logError } from '../util';
import {
	FETCH_EVENTS,
	FETCH_EVENT,
	FETCH_EVENTS_INC_DEL,
	UPDATE_EVENT,
	ADD_EVENT,
	DELETE_EVENT,
	UNDELETE_EVENT,
} from './actionTypes';

export const undeleteEvent = event => ({
	type: UNDELETE_EVENT,
	event,
});

export const updateEvent = event => ({
	type: UPDATE_EVENT,
	event,
});

export const deleteEvent = event => ({
	type: DELETE_EVENT,
	event,
});

export const addEvent = event => ({
	type: ADD_EVENT,
	event,
});

const fetchEvents = (events, from = '') => ({
	type: FETCH_EVENTS,
	events,
	from,
});

export const thunkFetchEvents = (clientID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { events } = await client.request(EventQueries.EVENTS, {
			client_id: clientID,
		});
		if (from !== 'EventPicker') dispatch(fetchEvents(events, from));
		else return events;
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEvents');
	}
};

const fetchEvent = (event, from = '') => ({
	type: FETCH_EVENT,
	event,
	from,
});

export const thunkFetchEvent = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { event } = await client.request(EventQueries.EVENT, {
			id: eventID,
		});
		dispatch(fetchEvent(event, from));
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEvent');
		dispatch(fetchEvent({ id: eventID, deleted_at: true }, from));
	}
};

const fetchEventsIncDel = (eventsIncDel, from = '') => ({
	type: FETCH_EVENTS_INC_DEL,
	eventsIncDel,
	from,
});

export const thunkFetchEventsIncDel = (clientID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventsIncludingDeleted } = await client.request(EventQueries.EVENTS_INCLUDING_DELETED, {
			client_id: clientID,
		});
		dispatch(fetchEventsIncDel(eventsIncludingDeleted, from));
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEventsIncDel');
	}
};
